// Walks an object, replaces values whose key is sensitive with '[REDACTED]',
// and returns a cloned tree. Keys are preserved so log shape is stable.
// Used by the logger before any transport (console / Sentry) sees the record.

const SENSITIVE_KEYS = new Set([
  // PII
  'email',
  'phone',
  'mobile',
  'first_name',
  'last_name',
  'full_name',
  'date_of_birth',
  'dob',
  'iban',
  'account_number',
  'bank_account_number',
  'address',
  // Auth / verification
  'password',
  'token',
  'access_token',
  'accesstoken',
  'refresh_token',
  'refreshtoken',
  'id_token',
  'idtoken',
  'otp',
  'verification_id',
  'verificationid',
  'authorization',
  // Documents
  'document_number',
  'documentnumber',
  'emirates_id',
  'emiratesid',
])

const MASK = '[REDACTED]'
const MAX_DEPTH = 8

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const isSensitiveKey = (key: string): boolean => SENSITIVE_KEYS.has(key.toLowerCase())

export const maskSensitiveFields = <T>(value: T, depth = 0): T => {
  if (depth > MAX_DEPTH) return value
  if (Array.isArray(value)) {
    return value.map((item) => maskSensitiveFields(item, depth + 1)) as unknown as T
  }
  if (!isPlainObject(value)) return value

  const masked: Record<string, unknown> = {}
  for (const [key, fieldValue] of Object.entries(value)) {
    masked[key] = isSensitiveKey(key) ? MASK : maskSensitiveFields(fieldValue, depth + 1)
  }
  return masked as T
}
